import { useState } from "react";
import { Link } from "react-router-dom";
import { ChevronDown, ArrowRight } from "lucide-react";
import { Glossary } from "../Glossary";
import { useLanguage } from "../../context/LanguageContext";
import { useHome } from "../../translations/home";
import { DemoCTA } from "./DemoCTA";

const HomeFAQ = () => {
  const { language } = useLanguage();
  const f = useHome(language).faq;
  const [open, setOpen] = useState(0);

  return (
    <section id="faq" className="bg-surfacec-50 border-t border-linec-200 py-20 lg:py-24" data-testid="faq-section">
      <Glossary><div className="wrap-cayus">
        <div className="max-w-3xl mx-auto">
          <div className="rule-cobalt mb-5" />
          <h2 className="font-bold text-3xl sm:text-4xl text-inkc-800 tracking-[-0.03em] mb-10">{f.title}</h2>

          <div className="flex flex-col gap-3 mb-12" data-testid="faq-list">
            {f.items.map((item, i) => (
              <div
                key={i}
                className={`bg-white rounded-xl border transition-colors ${open === i ? "border-cobalt-200 shadow-sm" : "border-linec-300"}`}
                data-testid={`faq-item-${i}`}
              >
                <button
                  onClick={() => setOpen(open === i ? -1 : i)}
                  className="w-full flex items-center justify-between gap-4 p-5 sm:p-6 text-left"
                  aria-expanded={open === i}
                  data-testid={`faq-question-${i}`}
                >
                  <span className="font-semibold text-inkc-800">{item.q}</span>
                  <ChevronDown
                    className={`w-5 h-5 text-inkc-400 flex-shrink-0 transition-transform ${open === i ? "rotate-180" : ""}`}
                  />
                </button>
                <div className={`faq-panel ${open === i ? "open" : ""}`} data-testid={`faq-answer-${i}`}>
                  <div>
                    <div className="px-5 sm:px-6 pb-6">
                      <p className="text-inkc-600 leading-relaxed border-l-2 border-cobalt-100 pl-4">{item.a}</p>
                      {item.link && (
                        <Link
                          to={item.link.to}
                          className="inline-flex items-center gap-1.5 text-sm font-medium text-cobalt-600 nav-underline mt-3 ml-4"
                          data-testid={`faq-link-${i}`}
                        >
                          {item.link.label}
                          <ArrowRight className="w-4 h-4" />
                        </Link>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>

          <p className="text-lg text-inkc-600 mb-7" data-testid="faq-foot">
            {f.foot}
          </p>
          <DemoCTA from="faq" />
        </div>
      </div></Glossary>
    </section>
  );
};

export default HomeFAQ;
